import {
    DATIQ_DEFAULT_EMPTY_LABEL,
    DATIQ_DEFAULT_ID,
} from '@dat/datiq-core/models';
import { IDatiqScreen } from './datiq-screen.interface';

export const emptyDatiqScreen: IDatiqScreen = {
    id: DATIQ_DEFAULT_ID('screen_'),
    title: DATIQ_DEFAULT_EMPTY_LABEL,
    description: DATIQ_DEFAULT_EMPTY_LABEL,
};
